const header = document.querySelector("#header");
const banner = document.querySelector(".banner");
const logo = document.querySelector(".logo");
const menu_element_active = document.querySelector(".header__active-menu-item");
const menu_elements = document.querySelectorAll(".header__menu-item");
const header_icons = document.querySelectorAll(".header__icon svg");
const disclosure_buttons = document.querySelectorAll(".disclosure__button span");
const disclosure_svgs = document.querySelectorAll(".disclosure__button svg path");

const color_dark_blue = '#1F2549';
const screenWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
const currentPath = window.location.pathname;

const isHomePage = /^\/(de|fr)?$/.test(currentPath);
const isContactPage = currentPath === '/pages/contact';

const applyStyles = (elements, styles) => {
    elements.forEach(element => {
        if (element) { 
            Object.assign(element.style, styles);
        }
    });
};


const applySVGAttributes = (elements, attribute, value) => {
    elements.forEach(element => element.setAttribute(attribute, value));
};

const styleHeaderOnTop = () => {
    header.style.backgroundColor = "transparent";
    
    if (isHomePage && window.pageYOffset === 0) {
        header.style.borderBottom = "none";
    } else {
        header.style.borderBottom = isContactPage || screenWidth < 768 ? "none" : "1px solid #f4f4f9";
    }

    const color = isHomePage ? "white" : color_dark_blue;
    const filter = isHomePage ? 'invert(1)' : 'invert(0)';

    applyStyles([logo, menu_element_active, ...menu_elements, ...disclosure_buttons], { color });
    applyStyles(header_icons, { filter });
    applySVGAttributes(disclosure_svgs, 'fill', color);
};

const styleHeaderNotOnTop = () => {
    header.style.backgroundColor = "white";
    header.style.borderBottom = screenWidth < 768 ? "none" : "1px solid #f4f4f9";

    applyStyles([logo, menu_element_active, ...menu_elements, ...disclosure_buttons], { color: color_dark_blue });
    applySVGAttributes(disclosure_svgs, 'fill', color_dark_blue);
    if (isHomePage) applyStyles(header_icons, { filter: 'invert(0)' });
};

if (window.pageYOffset > 0) {
    styleHeaderNotOnTop();
} else {
    styleHeaderOnTop();
}


document.addEventListener("scroll", () => {
    const scrollPosition = window.pageYOffset;
    if (banner ? scrollPosition === banner.offsetHeight : scrollPosition === 0) {
        styleHeaderOnTop();
    } else {
        styleHeaderNotOnTop();
    }
});


if (!isHomePage) {
    applyStyles(menu_elements, { color: color_dark_blue });
    applyStyles(header_icons, { filter: 'invert(0)' });
    applyStyles(disclosure_buttons, { color: color_dark_blue });
    applySVGAttributes(disclosure_svgs, 'fill', color_dark_blue);
    logo.style.color = color_dark_blue;
    if (menu_element_active) menu_element_active.style.color = color_dark_blue;
    header.style.borderBottom = '1px solid #e9e9ed';
}
